/**
 * ============================================================================
 * Outsource 模块 - 常量定义
 * ============================================================================
 *
 * @last-updated 2026-03-13
 * ============================================================================
 */

import {
  OutsourceExceptionAction,
  OutsourceExceptionStatus,
  OutsourceOrderStatus,
  OutsourcePriority,
  OutsourceQualityStatus,
  OutsourceReturnType,
} from './enums';

/** 委外订单状态标签 */
export const OUTSOURCE_ORDER_STATUS_LABELS: Record<number, string> = {
  [OutsourceOrderStatus.DRAFT]: '草稿',
  [OutsourceOrderStatus.PENDING]: '待审核',
  [OutsourceOrderStatus.CONFIRMED]: '已确认',
  [OutsourceOrderStatus.SHIPPED]: '已发料',
  [OutsourceOrderStatus.PROCESSING]: '加工中',
  [OutsourceOrderStatus.PARTIAL_RECEIVED]: '部分收货',
  [OutsourceOrderStatus.RECEIVED]: '全部收货',
  [OutsourceOrderStatus.SETTLED]: '已结算',
  [OutsourceOrderStatus.CLOSED]: '已关闭',
  [OutsourceOrderStatus.CANCELLED]: '已取消',
};

/** 委外优先级标签 */
export const OUTSOURCE_PRIORITY_LABELS: Record<number, string> = {
  [OutsourcePriority.URGENT]: '紧急',
  [OutsourcePriority.HIGH]: '高',
  [OutsourcePriority.MEDIUM]: '中',
  [OutsourcePriority.LOW]: '低',
};

/** 委外收货质检状态标签 */
export const OUTSOURCE_QUALITY_STATUS_LABELS: Record<number, string> = {
  [OutsourceQualityStatus.PENDING]: '待检',
  [OutsourceQualityStatus.QUALIFIED]: '合格',
  [OutsourceQualityStatus.REJECTED]: '不合格',
};

/** 委外异常处理状态标签 */
export const OUTSOURCE_EXCEPTION_STATUS_LABELS: Record<number, string> = {
  [OutsourceExceptionStatus.NONE]: '无异常',
  [OutsourceExceptionStatus.PENDING]: '待处理',
  [OutsourceExceptionStatus.PROCESSING]: '处理中',
  [OutsourceExceptionStatus.CLOSED]: '已关闭',
};

/** 委外异常处理动作标签 */
export const OUTSOURCE_EXCEPTION_ACTION_LABELS: Record<string, string> = {
  [OutsourceExceptionAction.REWORK]: '返工',
  [OutsourceExceptionAction.SUPPLEMENT]: '补料',
  [OutsourceExceptionAction.CLOSE]: '关闭',
};

/** 委外退料类型标签 */
export const OUTSOURCE_RETURN_TYPE_LABELS: Record<number, string> = {
  [OutsourceReturnType.EXCESS]: '多余退料',
  [OutsourceReturnType.QUALITY]: '质量问题退料',
};

/** 获取委外订单状态标签 */
export function getOutsourceOrderStatusLabel(status: number): string {
  return OUTSOURCE_ORDER_STATUS_LABELS[status] ?? '未知';
}

/** 获取委外优先级标签 */
export function getOutsourcePriorityLabel(priority: number): string {
  return OUTSOURCE_PRIORITY_LABELS[priority] ?? '未知';
}
